import { useEffect, RefObject } from 'react';

export default (
  refs: RefObject<HTMLElement | null>[],
  handler: (event: TouchEvent | MouseEvent) => void
): void => {
  useEffect(() => {
    const listener = (event: TouchEvent | MouseEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (refs.every(ref => !ref?.current)) {
        return;
      }
      if (
        refs.findIndex(ref => {
          if (event.target instanceof Node) {
            return ref?.current.contains(event.target);
          }
          return false;
        }) > -1
      ) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler]);
};
